﻿import {JSX} from "react";
import {TabPanelProps} from "./TabPanelProps";

export default function TabPanel(props: TabPanelProps): JSX.Element {
	return <>{props.children}</>;
}
